/* eslint-disable no-console */
import { TSatisfyClientToServerEvents } from '@/websockets/contexts/socket.context';
import { IUseSocketReturn } from '@/websockets/hooks/use-socket';
import { useCallback, useEffect, useRef } from 'react';
import { soundThree } from '@/assets/sound';
import { notify } from '@/utils/notify';
import { formatEventName } from '@/components/layouts/header/notification-popover';
import useSound from 'use-sound';
import { useEnabledTicketingSound, useIsUserOnSameTab, useNotificationActions } from '../stores/notification.store';

export type TNotification = {
  createdAt: string;
  eventName: string;
  message: string;
  receiverId: string;
  link: string;
};

export type TNotificationServerToClientEvents = {
  care_notification: (payload: TNotification) => void;
};

export default function useNotificationSocketListeners(
  socket: IUseSocketReturn<TNotificationServerToClientEvents, TSatisfyClientToServerEvents>
) {
  // HOOKS
  const { setIsHasNewNotification } = useNotificationActions();
  const enabledTicketingSound = useEnabledTicketingSound();
  const isUserOnSameTab = useIsUserOnSameTab();
  const eventListenersAttached = useRef(false);
  // const [playSoundThree] = useSound(soundThree, {
  //   volume: 0.5,
  //   interrupt: true,
  // });

  // console.log('enabledTicketingSound', enabledTicketingSound);

  // console.log('care notification enabled');

  // HANDLERS
  const handleNotification = useCallback(
    (payload: TNotification) => {
      // console.log('payload', payload);
      const { message, receiverId, link, eventName } = payload;
      // if (enabledTicketingSound) {
      //   if (!isUserOnSameTab) {
      //     playSoundThree();
      //   }
      // }

      const title = eventName ? formatEventName(eventName) : 'NoLimit Care';
      const content = message || 'No Messages';
      const options = {
        data: { receiverId: receiverId, url: link },
      };

      setIsHasNewNotification(true);
      notify(title, content, options);
    },
    [enabledTicketingSound, isUserOnSameTab, setIsHasNewNotification]
  );

  // EFFECTS
  useEffect(() => {
    if (!socket?.isConnected || eventListenersAttached.current) return;

    socket.on('care_notification', handleNotification);

    eventListenersAttached.current = true;

    return () => {
      socket.off('care_notification', handleNotification);
      eventListenersAttached.current = false;
    };
  }, [socket, handleNotification]);

  return null;
}
